export default __webpack_public_path__ + "static/media/investment.e1c1135b.svg";